import {defineStore} from "pinia";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export const useAlarmStore = defineStore('notification', {
    state: () => ({
        alarm: {},
        alarms: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setAlarm(alarm) {
            this.alarm = alarm
        },
        setAlarms(alarms) {
            this.alarms = alarms
        },
        addAlarm(alarm) {
            this.alarms.unshift(alarm)
        },
        updateAlarm(alarm) {
            let index = this.alarms.findIndex(cl => cl.id === alarm.id)
            this.alarms.splice(index, 1, alarm)
        },
        deleteAlarm(alarm) {
            let index = this.alarms.findIndex(cl => cl.id === alarm.id)
            this.alarms.splice(index, 1)
        },
        findAll(filter) {
            const {transformFilterValues} = useSharedMethod();
            this.loading = true;
            axios.get('/alarms', {params: transformFilterValues(filter)}).then((response) => {
                this.alarms = response.data.elements;
            }).finally(() => {
                this.loading = false;
            });
        },

    },
});